import { useEffect } from 'react'
import { Form } from 'antd'

const useInitializeRejectReasonAdvancedForm = (initialData) => {
  /* Getting form instance */
  const [form] = Form.useForm()

  /* Setting initial data */
  useEffect(() => {
    if (initialData) {
      /* Getting initial values */
      const { rejectReason, newspaper } = initialData

      /* Formatting date fields */
      const formValues = {
        rejectReason: {
          title: rejectReason?.['title'] ?? null,
          text: rejectReason?.['text'] ?? null
        },
        newspaper: newspaper ?? null
      }

      /* Setting initial values to form instance */
      form.setFieldsValue(formValues)
    }
  }, [initialData, form])

  return { form }
}

export default useInitializeRejectReasonAdvancedForm
